/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable  @typescript-eslint/strict-boolean-expressions */
import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { InputAdornment } from '@mui/material';
import SecondaryButton2 from 'shared-components/components/SecondaryButton2';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import './_accountInvite.scss';
import HookTextField from 'shared-components/hooks/HookTextField';
import type { IFormValues } from 'formsTypes';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CircularProgress from '@mui/material/CircularProgress';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import type { IInvitee, IPayload, IResponse } from './types';

interface Iendorment {
  show: boolean;
  setShow: (value: boolean) => void;
}

function EndAdornment(props: Iendorment): JSX.Element {
  const { show, setShow } = props;
  return (
    <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
      { show ? <VisibilityIcon onClick={(): void => { setShow(false); }} /> : <VisibilityOffIcon onClick={(): void => { setShow(true); }} />}

    </InputAdornment>
  );
}
function Logo(): JSX.Element {
  return (
    <svg width='125' height='24' viewBox='0 0 125 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1555_5393)'>
        <path fillRule='evenodd' clipRule='evenodd' d='M11.5768 0H31.9361C34.1409 0 35.9281 1.79086 35.9281 4V10.8C35.9281 11.9046 35.0345 12.8 33.9321 12.8H29.5409C28.8795 12.8 28.3433 13.3373 28.3433 14V20C28.3433 22.2091 26.556 24 24.3513 24H3.99202C1.78729 24 0 22.2091 0 20V13.2C0 12.6696 0.210293 12.1609 0.584617 11.7858C0.958941 11.4107 1.46663 11.2 1.99601 11.2H6.38723C7.04864 11.2 7.58483 10.6627 7.58483 10V4C7.58483 1.79086 9.37212 0 11.5768 0ZM20.7585 17.6V13.2C20.7585 12.0954 21.6521 11.2 22.7545 11.2H27.1457C27.8071 11.2 28.3433 10.6627 28.3433 10V6.4C28.3433 5.73726 27.8071 5.2 27.1457 5.2H16.3673C15.7058 5.2 15.1697 5.73726 15.1697 6.4V10.8C15.1697 11.9046 14.276 12.8 13.1737 12.8H8.78244C8.12102 12.8 7.58483 13.3373 7.58483 14V17.6C7.58483 18.2627 8.12102 18.8 8.78244 18.8H19.5609C20.2223 18.8 20.7585 18.2627 20.7585 17.6Z' fill='url(#paint0_linear_1555_5393)' />
        <path fillRule='evenodd' clipRule='evenodd' d='M104.543 5.28791V8.79991C103.515 7.6522 102.038 7.01216 100.499 7.04791C98.7625 7.0049 97.0988 7.74664 95.9681 9.06791C94.8024 10.3999 94.2116 12.2199 94.2116 14.4479C94.2116 16.6759 94.8024 18.5199 95.9681 19.8239C97.1119 21.1223 98.7712 21.846 100.499 21.7999C102.037 21.8215 103.509 21.1805 104.543 20.0399V21.0599C104.543 21.2808 104.722 21.4599 104.942 21.4599H108.184C108.404 21.4599 108.583 21.2808 108.583 21.0599V2.99591C108.584 2.8458 108.501 2.70787 108.368 2.63872C108.235 2.56957 108.074 2.58084 107.952 2.66791L104.715 4.95991C104.607 5.03452 104.543 5.15702 104.543 5.28791ZM104.543 16.7919C104.224 17.2219 103.802 17.5656 103.317 17.7919C102.788 18.0639 102.203 18.2077 101.609 18.2119C100.707 18.2428 99.8409 17.8616 99.2535 17.1759C98.6202 16.4123 98.2929 15.4399 98.3354 14.4479C98.2901 13.447 98.6173 12.4649 99.2535 11.6919C99.8398 11.0047 100.707 10.6232 101.609 10.6559C102.201 10.6555 102.786 10.7924 103.317 11.0559C103.804 11.2822 104.225 11.6275 104.543 12.0599V16.7919ZM64.9822 17.7962C65.0811 17.8511 65.1522 17.9455 65.1777 18.0559L65.7126 20.3439C65.7426 20.4962 65.6819 20.6521 65.5569 20.7439C64.6813 21.3253 63.649 21.624 62.5988 21.5999C61.3094 21.5999 60.3074 21.2439 59.6208 20.5559C58.9342 19.8679 58.5868 18.8759 58.5868 17.5999V6.74391C58.5874 6.61517 58.6498 6.49458 58.7545 6.41991L61.9122 4.18791C62.0337 4.10126 62.1932 4.08965 62.3259 4.1578C62.4585 4.22596 62.5422 4.36252 62.5429 4.51191V6.97591H64.8743C65.0947 6.97591 65.2735 7.15499 65.2735 7.37591V10.1759C65.2735 10.3968 65.0947 10.5759 64.8743 10.5759H62.5429V16.6359C62.5273 16.9812 62.6301 17.3214 62.8344 17.5999C63.0123 17.8267 63.285 17.9582 63.5729 17.9559C63.9435 17.9635 64.3121 17.8997 64.6587 17.7679C64.7656 17.731 64.8832 17.7413 64.9822 17.7962ZM51.3334 12.7599C52.0046 12.9518 52.6611 13.1924 53.2974 13.4799C53.9422 13.7845 54.4866 14.2675 54.8663 14.8719C55.2971 15.57 55.5136 16.3795 55.489 17.1999C55.509 18.5045 54.9051 19.74 53.8643 20.5239C52.7944 21.3719 51.3054 21.7999 49.4371 21.7999C48.2615 21.8223 47.092 21.6256 45.988 21.2199C45.1188 20.8694 44.2988 20.4069 43.5489 19.8439C43.3373 19.6799 43.3373 19.3559 43.7365 19.0719L45.5649 17.7799C45.8011 17.618 46.1057 17.5951 46.3633 17.7199C46.5922 17.8399 46.8397 17.9559 47.1058 18.0679C47.8868 18.4237 48.7312 18.6183 49.5888 18.6399C50.1453 18.6796 50.7011 18.5529 51.1857 18.2759C51.4975 18.0777 51.6824 17.7298 51.6727 17.3599C51.6727 17.0959 51.509 16.8799 51.1737 16.6959C50.7261 16.4699 50.2447 16.3186 49.7485 16.2479C49.0894 16.1385 48.4364 15.9943 47.7924 15.8159C47.119 15.6401 46.4608 15.41 45.8244 15.1279C44.4254 14.4905 43.5521 13.0665 43.6168 11.5279C43.6125 10.2705 44.1887 9.08186 45.1777 8.30791C46.1996 7.44791 47.6128 7.01191 49.3693 7.01191C51.0066 7.07764 52.6031 7.54313 54.02 8.36791C54.2623 8.49987 54.4195 8.74781 54.4357 9.02369C54.452 9.29957 54.325 9.56431 54.0998 9.72391L52.7385 10.6879C52.4967 10.8592 52.1802 10.8823 51.9162 10.7479L51.6128 10.5999C50.9115 10.3098 50.1599 10.1616 49.4012 10.1639C48.8969 10.1387 48.3962 10.261 47.9601 10.5159C47.6626 10.6736 47.4722 10.9789 47.4611 11.3159C47.4611 11.3999 47.4611 11.6479 47.9441 11.8919C48.3957 12.1067 48.8778 12.2497 49.3733 12.3159C50.0351 12.4237 50.6896 12.572 51.3334 12.7599ZM76.8423 7.46791C76.843 7.35374 76.795 7.24472 76.7103 7.1683C76.6257 7.09188 76.5125 7.05535 76.3992 7.06791C75.6787 7.14024 74.9791 7.35217 74.3393 7.69191C73.7154 8.00751 73.1465 8.4222 72.6547 8.91991V5.77591C72.6545 5.62718 72.5719 5.49087 72.4403 5.42201C72.3088 5.35316 72.1499 5.36313 72.028 5.44791L68.8344 7.71591C68.7285 7.7914 68.666 7.91375 68.6667 8.04391V20.9999C68.6667 21.2208 68.8454 21.3999 69.0659 21.3999H72.2595C72.48 21.3999 72.6587 21.2208 72.6587 20.9999V12.2639C73.0081 11.8241 73.4684 11.4858 73.992 11.2839C74.5743 11.0127 75.2064 10.8656 75.8483 10.8519H76.3753C76.4866 10.8609 76.5965 10.8227 76.6784 10.7467C76.7604 10.6707 76.8068 10.5638 76.8064 10.4519L76.8423 7.46791ZM85.6008 6.99991C87.1852 6.89247 88.7579 7.33766 90.0519 8.25991C91.2216 9.10791 91.8164 10.4999 91.8164 12.3999V21.0519C91.8164 21.2728 91.6377 21.4519 91.4172 21.4519H88.1956C87.9752 21.4519 87.7964 21.2728 87.7964 21.0519V20.3319C86.7904 21.2999 85.3932 21.7919 83.6328 21.7919C82.3711 21.7985 81.1484 21.3546 80.1837 20.5399C79.1531 19.6815 78.5829 18.3893 78.6427 17.0479C78.6427 15.5119 79.1537 14.3439 80.1597 13.5679C81.155 12.8036 82.379 12.399 83.6328 12.4199C85.4012 12.4199 86.8184 12.8839 87.7964 13.7999V12.4439C87.8168 11.8452 87.5365 11.276 87.0499 10.9279C86.4404 10.5106 85.7115 10.3041 84.9741 10.3399C83.7274 10.3406 82.5176 10.7635 81.5409 11.5399C81.4551 11.6101 81.3439 11.6413 81.2341 11.6261C81.1244 11.611 81.0258 11.5508 80.9621 11.4599L79.6128 9.54391C79.4911 9.37008 79.5261 9.13127 79.6926 8.99991C80.3873 8.44791 82.3393 7.15591 85.6008 6.99991ZM85.0859 18.9599C86.3354 18.9599 87.2455 18.6039 87.7964 17.8999V16.3279C87.2455 15.6239 86.3354 15.2639 85.0859 15.2639C84.4676 15.2418 83.8592 15.4231 83.3533 15.7799C82.9189 16.0933 82.6701 16.6039 82.6906 17.1399C82.6703 17.6639 82.9188 18.1619 83.3493 18.4599C83.8603 18.8075 84.4687 18.9826 85.0859 18.9599ZM122.786 8.25991C121.492 7.33766 119.92 6.89247 118.335 6.99991C115.074 7.15591 113.122 8.44791 112.427 8.99991C112.261 9.13127 112.226 9.37008 112.347 9.54391L113.697 11.4599C113.76 11.5508 113.859 11.611 113.969 11.6261C114.078 11.6413 114.19 11.6101 114.275 11.5399C115.252 10.7635 116.462 10.3406 117.709 10.3399C118.446 10.3041 119.175 10.5106 119.784 10.9279C120.271 11.276 120.551 11.8452 120.531 12.4439V13.7999C119.553 12.8839 118.136 12.4199 116.367 12.4199C115.113 12.399 113.889 12.8036 112.894 13.5679C111.888 14.3439 111.377 15.5119 111.377 17.0479C111.317 18.3893 111.888 19.6815 112.918 20.5399C113.883 21.3546 115.106 21.7985 116.367 21.7919C118.128 21.7919 119.525 21.2999 120.531 20.3319V21.0519C120.531 21.2728 120.71 21.4519 120.93 21.4519H124.152C124.372 21.4519 124.551 21.2728 124.551 21.0519V12.3999C124.551 10.4999 123.956 9.10791 122.786 8.25991ZM120.531 17.8999C119.98 18.6039 119.07 18.9599 117.82 18.9599C117.203 18.9826 116.595 18.8075 116.084 18.4599C115.653 18.1619 115.405 17.6639 115.425 17.1399C115.405 16.6039 115.653 16.0933 116.088 15.7799C116.594 15.4231 117.202 15.2418 117.82 15.2639C119.07 15.2639 119.98 15.6239 120.531 16.3279V17.8999Z' fill='#1A1A1A' />
      </g>
      <defs>
        <linearGradient id='paint0_linear_1555_5393' x1='0' y1='24' x2='35.9281' y2='24' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#00A4AB' />
          <stop offset='1' stopColor='#00CFA1' />
        </linearGradient>
        <clipPath id='clip0_1555_5393'>
          <rect width='125' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>

  );
}

export default function AccountInvite(): JSX.Element {
  const { token, inviteId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [inviteData, setInviteData] = useState<IInvitee>();
  const [showPassword, setShowPassword] = useState(false);

  const { mutate: getInviteInformation } = useMutation(async () => axios({
    url: 'api/auth-users/check-account/',
    method: 'POST',
    data: { token, inviteId },
  }), {
    onSuccess: (res: AxiosResponse<IResponse>) => {
      if (res.data.result.is_active) {
        enqueueSnackbar('You’ve already accepted this invitation.');
        navigate('/signin');
      }
      setInviteData(res.data.result);
    },
    onError: () => {
      enqueueSnackbar('Invalid or expired invite token.');
      navigate('/signin');
    },
  });

  const { mutate: acceptInvite, isLoading } = useMutation(async (payload: IPayload) => axios({
    url: 'api/auth-users/confirm-account/',
    method: 'POST',
    data: payload,
  }), {
    onSuccess: () => {
      navigate('/signin', { state: 'You have successfully confirmed your invitation. Please signin using your credentials.' });
    },
    onError: () => {
      enqueueSnackbar('Error occured. Please try again.');
    },
  });

  useEffect(() => {
    if ((token != null) && (inviteId != null)) {
      getInviteInformation();
    }
  }, [getInviteInformation, inviteId, token]);

  const defaultValues: IPayload = {
    first_name: '',
    last_name: '',
    password: '',
    token: '',
  };

  const schema = yup.object().shape({
    first_name: yup.string().required('This field is required').matches(/^[aA-zZ\s]+$/, 'This field should only contain characters'),
    last_name: yup.string().required('This field is required').matches(/^[aA-zZ\s]+$/, 'This field should only contain characters'),
    password: yup.string().required('This field is required'),
  });

  const {
    control, formState, handleSubmit,
  } = useForm<IFormValues>({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });

  const { errors } = formState;

  const onSubmit = (data: IPayload): void => {
    const payload = data;
    payload.token = token;
    acceptInvite(payload);
  };

  return (
    <div className='invite-content'>
      <section>
        <Link style={{ display: 'block', textAlign: 'center' }} to='/'><Logo /></Link>
        <h1 className='invite-title'>Let’s collaborate!</h1>
        <h4 className='invite-subtitle'>
          You’re accepting
          {' '}
          {inviteData?.invite_firstname}
          {' '}
          {inviteData?.invite_lastname}
          &#39;s invite to
          Strada
        </h4>
        <form onSubmit={handleSubmit(onSubmit)} className='w-100'>
          <p className='input-label'>First name*</p>
          <HookTextField
            name='first_name'
            control={control}
            errors={errors}
            maxLength={150}
          />
          <p className='input-label'>Last name*</p>
          <HookTextField
            name='last_name'
            control={control}
            errors={errors}
            maxLength={150}
          />
          <p className='input-label'>Password*</p>
          <HookTextField
            name='password'
            control={control}
            errors={errors}
            maxLength={150}
            type={showPassword ? 'text' : 'password'}
            endAdornment={<EndAdornment show={showPassword} setShow={setShowPassword} />}
          />
          <p className='invite-description mt-0 mb-3'>
            You’re signing in as
            {' '}
            {inviteData?.email}
          </p>
          {!isLoading
            ? (
              <SecondaryButton2
                type='submit'
                fullWidth
              >
                {' '}
                Get started
              </SecondaryButton2>
            )
            : (
              <div className='progress-div'>
                <CircularProgress style={{ width: '20px', height: '20px', color: '#A1A1AA' }} />
              </div>
            )}
        </form>
        <p className='invite-description'>
          <span>By continuing, you agree to the </span>
          <Link to='/terms-and-conditions'>Terms of Service</Link>
          <span> and </span>
          <Link to='/privacy-policy'>Privacy Policy</Link>
          .
        </p>
      </section>
    </div>
  );
}
